import { Component } from '@angular/core';
import { DemoRequestService } from 'src/app/dialogs/demo-choice-dialog/demo-request.service';

@Component({
  selector: 'app-ai-headhunting-section',
  templateUrl: './ai-headhunting-section.component.html',
  styleUrls: ['./ai-headhunting-section.component.scss'],
})
export class AiHeadhuntingSectionComponent {
  constructor(private demoRequestService: DemoRequestService) {}

  openDemoChoice() {
    this.demoRequestService.openDemoChoice();
  }
}
